// A move or decision on a deal that says why (TX-US-0043): a reopening, a cancellation, a return
// or a rejection. The shared MoveDialog with its reason, which the confirm waits on; `act` is
// given the reason trimmed.

import { useState } from 'react';

import MoveDialog, { ReasonField } from '../ui/MoveDialog.jsx';

// trex/deals/approval.py
const MAX_REASON_LENGTH = 2000;

export default function ReasonDialog({
  title, hint, confirmLabel, busyLabel, danger = false, act, refusal, onClose,
}) {
  const [reason, setReason] = useState('');

  return (
    <MoveDialog title={title} hint={hint} submitLabel={confirmLabel} busyLabel={busyLabel}
                danger={danger} ready={Boolean(reason.trim())} move={() => act(reason.trim())}
                refusal={refusal} onClose={onClose}>
      <ReasonField value={reason} onChange={setReason} maxLength={MAX_REASON_LENGTH} />
    </MoveDialog>
  );
}
